import KiListItem from './ki-list-item';
import autoRun from '../../decorators/autoRun';

export default class KiListItemGroup extends KiListItem {
  static get properties() {
    return {
      folded: { type: Boolean },
    };
  }

  get itemNode() {
    return this.querySelector('.label'); // TODO
  }

  constructor() {
    super();
    this.setAttribute('tabindex', '-1');
  }

  @autoRun('folded')
  _updateSelectedState() {
    this.classList.toggle('folded', !!this.folded);
  }
}

customElements.define('ki-list-item-group', KiListItemGroup);
